import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { FramePickerService } from '@ui/look-book-front/print-frames/print-frames-front/frame-picker.service';

@Pipe({
    name: 'printFrameName',
    standalone: false
})
export class PrintFrameNamePipe implements PipeTransform {
  constructor(private framePickerService: FramePickerService) {}

  transform(value: Record<string, string>): Observable<string> {
    return this.framePickerService.getPrintFrameName(value);
  }
}
